import {
  TDocumentStatus,
  TDocumentType,
  TDocument,
} from '../../apis/documents/documents.interfaces';
import { mockUserAction } from '../users/userAction';
import { mockDocument } from '../documents/documentMock';

// Generate student documents with Indian context
const indianNames = [
  'Ramesh Agarwal', 'Priya Sharma', 'Arjun Kumar', 'Anjali Patel', 'Vikram Singh',
  'Kavita Reddy', 'Rajesh Mehta', 'Meera Iyer', 'Amit Gupta', 'Sunita Joshi',
];

function generateStudentDocument(index: number, docType: TDocumentType, name: string): TDocument {
  const statuses = [TDocumentStatus.VERIFIED, TDocumentStatus.PENDING, TDocumentStatus.REJECTED, TDocumentStatus.SUBMITTED];
  const status = statuses[index % statuses.length];
  
  const docNameMap: Record<TDocumentType, string> = {
    [TDocumentType.BIRTH_CERTIFICATE]: `Birth Certificate - ${name}`,
    [TDocumentType.TRANSFER_CERTIFICATE]: `Transfer Certificate - ${name}`,
    [TDocumentType.AADHAR_CARD]: `Aadhar Card - ${name}`,
    [TDocumentType.PAN_CARD]: `PAN Card - ${name}`,
    [TDocumentType.PREVIOUS_MARKSHEET]: `Previous Marksheet - ${name}`,
    [TDocumentType.MEDICAL_CERTIFICATE]: `Medical Certificate - ${name}`,
    [TDocumentType.SALARY_SLIP]: `Salary Slip - ${name}`,
    [TDocumentType.RESIGNATION_LETTER]: `Resignation Letter - ${name}`,
    [TDocumentType.JOINING_LETTER]: `Joining Letter - ${name}`,
    [TDocumentType.PROMOTION_LETTER]: `Promotion Letter - ${name}`,
    [TDocumentType.LEAVE_LETTER]: `Leave Letter - ${name}`,
    [TDocumentType.PHOTO]: `Profile Photo - ${name}`,
    [TDocumentType.OTHER]: `Document - ${name}`,
    [TDocumentType.HR_DOCUMENT]: `HR Document - ${name}`,
  };
  
  const baseDate = new Date('2024-01-15');
  const submissionDate = new Date(baseDate.getTime() + index * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
  const verificationDate = status === TDocumentStatus.VERIFIED 
    ? new Date(baseDate.getTime() + (index + 1) * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    : undefined;
  
  return {
    ...mockDocument,
    documentId: `doc-${docType}-${index}`,
    userId: `student-${String(index).padStart(3, '0')}`,
    documentType: docType,
    documentName: docNameMap[docType] || `Document - ${name}`,
    submissionDate,
    verificationDate,
    status,
    remarks: status === TDocumentStatus.VERIFIED ? `Document verified successfully for ${name}` :
             status === TDocumentStatus.REJECTED ? `Document quality issues for ${name}` : undefined,
    fileUrl: `https://example.com/${docType}-${index}.pdf`,
    thumbnailUrl: docType === TDocumentType.PHOTO || docType === TDocumentType.AADHAR_CARD 
      ? `https://example.com/${docType}-${index}-thumb.jpg` : undefined,
    description: `${docNameMap[docType]} for student ${name}`,
    uploadedAt: mockUserAction,
  };
}

export const mockStudentDocuments: TDocument[] = Array.from({ length: 60 }, (_, i) => {
  const nameIndex = i % indianNames.length;
  const name = indianNames[nameIndex];
  const docTypes = [
    TDocumentType.BIRTH_CERTIFICATE,
    TDocumentType.TRANSFER_CERTIFICATE,
    TDocumentType.AADHAR_CARD,
    TDocumentType.PREVIOUS_MARKSHEET,
    TDocumentType.MEDICAL_CERTIFICATE,
  ];
  const docType = docTypes[i % docTypes.length];
  return generateStudentDocument(i, docType, name);
});
